<script setup lang="ts">

import DialogFrame from "@/components/DialogFrame.vue";
import {onMounted, ref} from "vue";
import {authStore} from "@/stores/auth-store";

const show = ref<boolean>(false)

onMounted(() => {

    // このコメントアウトを解除すると1回限りの表示となります。
    // if (!authStore.state.staffNotificationShowed) {
    //     show.value = true
    //     authStore.commit("updateStaffNotificationShowed", true)
    // }

    // こちらが有効だと毎回表示
    show.value = false
})

const onClickClose = () => {
    show.value = false
}

</script>

<template>
<DialogFrame
    :on-click-close="onClickClose"
    title="お知らせ"
    :show-dialog="show"
>
    <template v-slot:dialogContent>
        <div class="container-fluid h-100 pt-4">
            <div class="row note-row">
                <div class="col">８月２２日、アト前払いシステムでエラーが発生し、誤った金額の振込手続きがされていることが判明しました。
                    ご迷惑をお掛けしましたこと、心より深くお詫び申し上げます。
                    具体的な誤った金額、返金方法に関して、メールにてご連絡を差し上げました。
                    ご確認の程、宜しくお願い申し上げます。
                    株式会社マス・コア</div>
            </div>
            <div class="row justify-content-center button-row">
                <button
                    class="btn btn-info w-100"
                    @click="onClickClose"
                >OK</button>
            </div>
        </div>
    </template>
</DialogFrame>
</template>

<style scoped lang="scss">
    .note-row {
        height: calc(100% - 40px);
    }

    .button-row {
        height: 40px;
    }
</style>
